import React from 'react';
import '../../../assets/css/common/video/discuss.css';
import config from '../../../assets/js/conf/config.js';
import {request,request2} from '../../../assets/js/libs/request.js';
import {connect} from 'react-redux';
import {lazyImg} from '../../../assets/js/utils/util.js';
import { Toast, Modal, Button } from 'antd-mobile';
import '../../../assets/css/common/alertModle.css';

// import 'emoji-mart/css/emoji-mart.css';
// import { Picker } from 'emoji-mart';
// import { Emoji } from 'emoji-mart'
import VideoDiscuss from './discuss.js';
const alert = Modal.alert;

class VideoOther extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			MessageArr: [],
			outlineId: props.state.outlineId.Id,
			startTime: '',
			uId: '',
			scHei: 0,
			phone: localStorage['LoginData'] !== undefined?JSON.parse(localStorage['LoginData']).phone:'',
			IputVal: '',
			danmuFlag: false,
			inputa: true,
			allPageHeight: 0,
			bottomJuLi: -1,
			modal: false,
			AlertArr: [
				{
					name: '学员禁言模式',
					switchFlag: false,
					type: 0
				},
				{
					name: '邀请讲师',
					type: 1
				},
				{
					name: '首页',
					type: 1
				}
			],	//'学员语音发言',
			//SwitchFlag: [false],
			LoginData: localStorage['LoginData'] != undefined?JSON.parse(localStorage['LoginData']):'',
			S058Date: {
				merchandiseType: 0,
				evaluateType: 0
			}
		}
		this.discussStyle = {display: 'none'};
		this.timer = null;
	}
	componentDidMount() {
		let that = this;
		this.ListenScroll();
		
		// this.timer = setInterval(function(){
		// 	that.getOtherMessage();
		// }, 1500)
      	if(that.state.outlineId){
			that.getOtherMessage();
		}
		
		let Docheight = document.documentElement.clientHeight?document.documentElement.clientHeight:document.body.clientHeight;
		let hei1 = parseInt(this.getHeight(document.querySelector(".video"), 'height'));
		let hei2 = parseInt(this.getHeight(document.querySelector(".quick-nav"), 'height'));
		let hei3 = parseInt(this.getHeight(document.querySelector(".video-content"), 'height'));
		let hei4 = parseInt(this.getHeight(document.querySelector(".sub-header"), 'height'));
		
		this.otherContentHeight = Docheight-hei1-hei2-hei3-hei4*2.8;
		
		//预约 收藏 评论 状态信息
		request(config.baseUrl+'api/Study/S058?merchandiseId='+this.state.outlineId, "post").then(res=>{
		    if(res.code == 0){
		    	this.setState({
					S058Date: res.data
				})
		    }
			//console.log(this.state.S058Date)
		});
	}
	ListenScroll(){
		let that = this;
		var bScroll=true;
		let otherCScrol = true;
		this.refs['other-content'].addEventListener("scroll", function(e){
			if(!bScroll){
	            return;
	        }
			clearInterval(that.timer);
			otherCScrol = false;
			
	        bScroll=false;
			setTimeout(function(){
                var scrollTop = e.target.scrollTop;    //滚动条距离顶部的高度
				var scrollHeight = parseInt( that.getHeight( document.querySelector(".ul") ,'height'));   //当前页面的总高度
				var clientHeight =  parseInt( that.getHeight( document.querySelector(".other-content1") ,'height'));    //当前可视的页面高度
				
				//console.log(scrollTop + clientHeight , scrollHeight)
	
				if(scrollTop + clientHeight >= scrollHeight){   //距离顶部+当前高度 >=文档总高度 即代表滑动到底部 
				    //滚动条到达底部
				    //console.log(111111)
				    that.timer = setInterval(function(){
						that.getOtherMessage();
					}, 5000);
				}else if(scrollTop<=0){
					otherCScrol = true;
					//console.log(scrollTop + clientHeight , scrollHeight)
				}
                bScroll=true;
                
            },200);
		},false);
		
		//滑动加载
		var currntY = 0,
			lastY = 0,
			direction = 0;
		
		document.getElementById("ul").addEventListener('touchstart', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			var ev = e || window.event;
			lastY = parseInt( ev.targetTouches[0].clientY );
			//console.log("lastY",lastY)
		}, false);
		       
		document.getElementById("ul").addEventListener('touchmove', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			var ev = e || window.event;
			currntY = parseInt( ev.changedTouches[0].clientY );
			//console.log(otherCScrol,"currntY",currntY)
			direction =  currntY - lastY;
		    if (direction > 0) {
		        //console.log("下")
		        
		        that.setState({
		        	scHei: direction
		        })
		        if(!bScroll){
		            return;
		       	}
		        bScroll=false;
		        //滚动条到达顶部
				setTimeout(function(){
					that.getOtherMessage2();
				}, 200);
			} else {
			    //console.log("上")
			}
		}, false);
		document.getElementById("ul").addEventListener('touchend', function(e) {
			var ev = e || window.event;
			ev.stopPropagation();
			if(!otherCScrol){
				return
			}
			that.setState({
		    	scHei: 0
		    })
			bScroll=true;
		}, false);
	}
	getOtherMessage2(){
		let that = this;
		//获取历史信息记录
		let data = {
			  "merchandiseId": that.state.outlineId,
			  "count": 10,
			  "startTime": that.state.startTime,
			  "order": "desc",
			  'uId': that.state.uId
			}
			
			request(config.baseUrl+'api/Study/M01', "post", data).then(res=>{
				if(res.code === 0) {
					if(res.data.length > 0) {
						//res.data.reverse();
						let MessageArr = that.state.MessageArr;
						
						let time= res.data[0].Msg_CrtTime.slice(0, 19).replace(/-/g, '/');
	            		for(let i=0;i<res.data.length;i++){
	            			let NextTime = i<= res.data.length-2 ? res.data[i+1].Msg_CrtTime.slice(0, 19).replace(/-/g, '/'):0;
	            			if(i<= res.data.length-2 && (new Date(time) - new Date(NextTime) > 60000)){
	            				time = NextTime;
	            				res.data[i].timeFlag = true;
	            			}else{
	            				res.data[i].timeFlag = false;
	            			}
	            			MessageArr.unshift(res.data[i])
	            		}
						
//						res.data.forEach(item=>{
//							let resultArr = item.Msg_Context.split(':');
//  						item.ContextArr = resultArr;
//	            			MessageArr.unshift(item)
//	            		})
	            		that.setState({
		            		MessageArr: MessageArr,
		            		startTime: res.data[res.data.length-1].Msg_CrtTime,
        					uId: res.data[res.data.length-1].UID
		            	},()=>{
		            		lazyImg();
		            	})
	            		//console.log(that.state.MessageArr)
					}
				}
			})
	}
	getOtherMessage(startTime, uId){
		//console.log(1111)
		//获取最新信息
		let data = {
			  "merchandiseId": this.state.outlineId,
			  "count": 10,
			  "startTime": startTime,
			  "order": "desc",
			  'uId': uId
		}
		request2(config.baseUrl+'api/Study/M01', "post", data).then(res=>{
            if(res.code == 0){
            	if(res.data.length>0){
            		let time= res.data[0].Msg_CrtTime.slice(0, 19).replace(/-/g, '/');
            		for(let i=0;i<res.data.length;i++){
            			let NextTime = i<= res.data.length-2 ? res.data[i+1].Msg_CrtTime.slice(0, 19).replace(/-/g, '/'):0;
            			if(i<= res.data.length-2 && (new Date(time) - new Date(NextTime) > 60000)){
            				time = NextTime;
            				res.data[i].timeFlag = true;
            			}else{
            				res.data[i].timeFlag = false;
            			}
            		}
//          		res.data.forEach(item => {
//          			let resultArr = item.Msg_Context.split(':');
//          			item.ContextArr = resultArr;
//          		})
            		//颠倒数组中元素的顺序
            		res.data.reverse();
            		
            		this.setState({
	            		MessageArr: res.data,
	            		startTime: res.data[res.data.length-1].Msg_CrtTime,
	            		uId: res.data[res.data.length-1].UID
	            	},()=>{
	            		lazyImg();
	            	})
            	}
            }
        });
	}
	getHeight( obj, style ){
	　　return window.getComputedStyle(obj).getPropertyValue(style);
	}
	componentWillUnmount(){
		this.setState = (state, callback)=>{
			return;
		}
		clearInterval(this.timer);
	}
	questionFlagClick(e){
		let questionFlag = this.state.questionFlag;
		this.setState({
			questionFlag: !questionFlag
		})
		e.preventDefault();
	}
	discuss(display){
		this.setState(
			this.discussStyle = display
		)
	}
	clickDanMu(){
		let danM = this.state.danmuFlag;
		this.setState({
			danmuFlag: !danM
		})
	}
	subMessage(){
		let that = this;
		//发送信息
		let data = {
			  "messageContent": this.state.IputVal,
			  "merchandiseId": this.state.outlineId,
			  "isQuestion": this.state.questionFlag?1:0
			}
		this.allPage();
		if(this.state.IputVal == ""){
			//Toast.info("请输入您的手机号",2);
			return
		}
		request(config.baseUrl+'api/Study/M02', "post", data).then(res=>{
            if(res.code == 0){
            	//console.log(res)
            	that.getOtherMessage();
            	this.setState({
            		IputVal: ''
            	})
            }
        });
        
	}
	allPage(){
		//隐藏输入框
	    let that = this;
	    setTimeout(function(){
			that.setState({
				inputa: true,
				allPageHeight: 0,
				bottomJuLi: -1
			});
		},100);
	}
	otherIuptClick(){
		this.setState({
			inputa: false,
			allPageHeight: 50,
			bottomJuLi: 0
		});
		document.getElementById("iput").focus();
	}
	exitButtom(){
		let modal = this.state.modal;
		this.setState({
			modal: !modal
		})
	}
	exitBtn(index){
		this.exitButtom();
		if(index == 1){
			this.props.history.replace('/againlogin');
		}
	}
	SwitchClick(index, name){
		console.log(index,name)
		let AlertArr = this.state.AlertArr;
		AlertArr[index].switchFlag = !AlertArr[index].switchFlag;
		
		this.setState({
			AlertArr: AlertArr
		})
		if(name == "学员禁言模式"){
			let onoff = AlertArr[index].switchFlag?1:0;
			request(config.baseUrl+'api/AM/AM07?merchandiseId='+this.state.outlineId+'&onoff='+ onoff, "post").then(res=>{
			    if(res.code == 0){
			    	//console.log(res)
					if(onoff == 1){
						Toast.info("开启禁言",2);
					}else{
						Toast.info("解除禁言",2);
					}
			    }
			});
		}else if(name == "邀请讲师"){
			request(config.baseUrl+'api/AM/AM10?merchandiseId='+this.state.outlineId, "post").then(res=>{
			    if(res.code == 0){
			    	//console.log(res)
					window.location.href = res.data;
			    }
			});
		}else if(name == "首页"){
			this.props.history.replace('/home/index');
		}
	}
	Closealert(index){
		this.setState({
			modal: false
		})
		//结束直播
		if(index != 1){
			return
		}
		request(config.baseUrl+'api/AM/AM09?merchandiseId='+this.state.outlineId, "post").then(res=>{
		    if(res.code == 0){
		    	//console.log(res)
		    }
		});
	}
	role4(val){
		//console.log(val,this.state.S058Date)
		if(val == '首页'){
			this.props.history.replace('/home/index');
		}else if(val == '排行榜'){
			this.props.history.push('/s059Rank');
		}else if(val == '评价'){
			//this.props.history.replace('/home/index');
		}else if(val == '收藏'){
			let data = {
				"merchandiseId": this.state.outlineId,
				"accountId": this.state.LoginData.accId
			}
			let S058Date = this.state.S058Date;
			if(S058Date.merchandiseType == 0){
				request(config.baseUrl+'api/Study/S052', "post", data).then(res=>{
				    if(res.code == 0){
						S058Date.merchandiseType = 1;
						Toast.info(res.message,2);
				    	this.setState({
							S058Date: S058Date
						})
				    }
				});
			}else if(S058Date.merchandiseType == 1){
				request(config.baseUrl+'api/Study/S053', "post", data).then(res=>{
				    if(res.code == 0){
						S058Date.merchandiseType = 0;
						Toast.info(res.message,2);
				    	this.setState({
							S058Date: S058Date
						})
				    }
				});
			}
			//this.props.history.replace('/home/index');
		}
	}
	render() {
		return(
			<div className={'other'}>
				<div className={'other-content other-content1'} ref='other-content' style={{height: this.otherContentHeight + 'px'}}>
					<div className={'shauxin'}>
						下拉刷新
					</div>
					<ul id='ul' className='ul' style={{transitionDuration: '0ms', transform: 'translate3d(0px, '+this.state.scHei+'px, 0px)'}}>
						{
							this.state.MessageArr.length>0 &&
							this.state.MessageArr.map((item, index)=>{
								if(this.state.phone !== item.Ac_AccName && item.accType != 1){
									return(
										<li key={index}>
											<p className={item.timeFlag?'liTime':'hide'}>{item.Msg_CrtTime.slice(0, 19)}</p>
											<div className={'liName'}>
												<div className={'li-img'}>
													<img src={item.Ac_Photo?item.Ac_Photo:require('../../../assets/images/common/my1.png')} alt={item.Ac_Name} />
												</div>
												<div className={'li-name'}>
													<span className={'guanli'}>{item.roleTag}</span>
													<span className={'name'}>{item.Ac_Name}</span>
													<div className={'li-cont'} style={{paddingLeft: item.Msg_IsQuestion?'0.7rem':''}}>
														<div className={item.Msg_IsQuestion?'':'hide'}>
															<span className={'wen'}>问</span>
														</div>
														<div>
															{item.Msg_Context}
														</div>
													</div>
												</div>
											</div>
										</li>
									)
								}else if(this.state.phone == item.Ac_AccName && item.accType != 1){
									return (
										<li className={'myQus'} key={index}>
											<p className={item.timeFlag?'liTime':'hide'}>{item.Msg_CrtTime.slice(0, 19)}</p>
											<div className={'liName'}>
												<div className={'li-name'}>
													<span className={'guanli'}>{item.roleTag}</span>
													<span className={'name'}>{item.Ac_Name}</span>
													<div className={'li-cont'} style={{paddingLeft: item.Msg_IsQuestion?'0.7rem':''}}>
														<div className={item.Msg_IsQuestion?'':'hide'}>
															<span className={'wen'}>问</span>
														</div>
														<div>
															{item.Msg_Context}
														</div>
													</div>
												</div>
												<div className={'li-img'}>
													<img src={item.Ac_Photo?item.Ac_Photo:require('../../../assets/images/common/my1.png')} alt={item.Ac_Name} />
												</div>
											</div>
										</li>
									)
								}
							})
						}
					</ul>
					<div className={this.state.danmuFlag?'other-xuanfu':'hide'}>
					{
						this.state.MessageArr.length>0 &&
						this.state.MessageArr.slice(this.state.MessageArr.length-3).map((item, index)=>{
							return(
								<div key={index}>
									<span>
										<img src={item.Ac_Photo?item.Ac_Photo:require('../../../assets/images/common/my1.png')} alt={item.Ac_Name} />
									</span>
									<p>
										<span className={'hide'}>问</span>
										<span>{item.Msg_Context}</span>
									</p>
								</div>
							)
						})
					}
					</div>
					<div className={'other-tan'} onClick={this.clickDanMu.bind(this)}>
						<img src={this.state.danmuFlag?require('../../../assets/images/video/dan.png'):require('../../../assets/images/video/dan2.png')} alt='图片' />
					</div>
				</div>
				<div className={this.state.inputa?'other-foot':'hide'}>
					<div className={'other-iupt'} onClick={this.otherIuptClick.bind(this)}>
					{
						 // style={{'width': this.state.LoginData.role == 5?'3.6rem':'4.6rem'}}
					}
						<input disabled="disabled" placeholder="说点什么吧！" value={this.state.IputVal} />
						<div className={this.state.questionFlag?'other-spa1 active':'other-spa1'}>
							<span className={'TiWenFlag'}></span>
							<span>提问</span>
						</div>
					</div>
					<div className={'other-icon icon2'} onClick={this.discuss.bind(this,{display: 'block'})}></div>
					{
						// <div className={this.state.LoginData.role == 5?'other-icon icon3':'hide'} onClick={this.exitButtom.bind(this)}></div>
						//
					}
					<div className={'other-icon icon3'} onClick={this.exitButtom.bind(this)}></div>
				</div>
				<div className={'other-all-page'} onClick={this.allPage.bind(this)} style={{height: this.state.allPageHeight+'vh'}}>
				</div>
				<div className={'other-foot other-foot2'} style={{bottom: this.state.bottomJuLi+'rem'}}>
					<div className={'other-iupt'}>
						<textarea id='iput' placeholder="说点什么吧！" value={this.state.IputVal} onChange={(e)=>{this.setState({IputVal: e.target.value})}} />
						<div className={this.state.questionFlag?'other-spa1 active':'other-spa1'} onClick={this.questionFlagClick.bind(this)}>
							<span className={'TiWenFlag'}></span><span>提问</span>
						</div>
					</div>
					<div className={'other-iupt-sub'} onClick={this.subMessage.bind(this)}>发送</div>
				</div>
				<div className={this.state.modal?'bg':'hide'}>
					<div className={'alertBox'}>
						<div className={'exitTitle'}>
							更多
							<span className={"shareFootClose"} onClick={this.exitButtom.bind(this)}>
								<img src={require('../../../assets/images/common/search_x.png')} />
							</span>
						</div>
						<div className={this.state.LoginData.role == 5?'alertCont':'hide'}>
						{
							this.state.AlertArr.map((item, index)=>{
								return (
									<div key={index} onClick={this.SwitchClick.bind(this, index, item.name)}>
										{item.name}
										<span className={item.type == 0?'spImg2':'hide'}>
											<img src={item.switchFlag?require('../../../assets/images/video/open.png'):require('../../../assets/images/video/open2.png')} />
										</span>
										<span className={item.type == 1?'spImg':'hide'}>
											<img src={require('../../../assets/images/common/right.png')} />
										</span>
									</div>
								)
							})
						}
							<Button className={'jiesu'} onClick={() =>
							        alert('', '确定结束此课程直播？', [
							          { text: '取消', onPress: () => this.Closealert('0') },
							          { text: '确定', onPress: () => this.Closealert('1') },
							        ])
							      }
							    >
							      结束直播
							    </Button>
						</div>
						<div className={this.state.LoginData.role != 5?'alertCont2':'hide'}>
							<div onClick={this.role4.bind(this, '首页')}>
								<img src={require('../../../assets/images/video/PJ1.png')} />
								<span>首页</span>
							</div>
							<div onClick={this.role4.bind(this, '排行榜')}>
								<img src={require('../../../assets/images/video/PJ2.png')} />
								<span>邀请排行榜</span>
							</div>
							<div onClick={this.role4.bind(this, '评价')}>
								<img src={this.state.S058Date.evaluateType == 0?require('../../../assets/images/video/PJ3.png'):require('../../../assets/images/video/PJ3-1.png')} />
								<span>评价</span>
							</div>
							<div onClick={this.role4.bind(this, '收藏')}>
								<img src={this.state.S058Date.merchandiseType == 0?require('../../../assets/images/video/PJ4.png'):require('../../../assets/images/video/PJ4-1.png')} />
								<span>收藏</span>
							</div>
						</div>
					</div>
					
				</div>
				<VideoDiscuss discussStyle={this.discussStyle} display={this.discuss.bind(this)} />
		    </div>
		);
	}
}
export default connect((state)=>{
	return {
		state: state
	}
})(VideoOther)